module.exports = __webpack_public_path__ + "media/images/emblems/Vuflens-la-Ville-coat_of_arms-02cc4ec8c0a66cef7125d4901e587fb0.svg";